$(document).ready(function () {
    let p = $("body").attr("p");
    let language = $("body").attr("lang");
    var calendar;

    if (language === "no") {
        language = "nb";
    }

    if (p === "organizer_event_calendar") {
        let eventId = $("body").attr("event_id");
        let orderOrigin = $("#order_origin").children("option:selected").val();
        let organizer_event_calendar_ajax_lock = false;

        if ($("body").attr("order_origin") !== undefined) {
            orderOrigin = $("body").attr("order_origin");
            $("#order_origin").val(orderOrigin);
        }

        let today = new Date();
        let start = new Date(today.getFullYear(), today.getMonth(), 1, 0, 0, 0);
        let end = new Date(
            today.getFullYear(),
            today.getMonth() + 2,
            1,
            0,
            0,
            0
        );

        start = start.toISOString().slice(0, 19).replace("T", " ");
        end = end.toISOString().slice(0, 19).replace("T", " ");

        let params = {
            event_id: eventId,
            order_origin: orderOrigin,
            start,
            end,
        };

        function renderEventCalendar(events) {
            var calendarEl = document.getElementById("event-booked-calendar");
            if (!calendarEl) {
                console.error("Calendar element not found");
                return;
            }

            if (!calendar) {
                calendar = new FullCalendar.Calendar(calendarEl, {
                    initialView: "multiMonth",
                    headerToolbar: {
                        left: "prev,next",
                        right: "title",
                    },
                    locale: language,
                    showNonCurrentDates: false,
                    events: events,
                    views: {
                        multiMonth: {
                            multiMonthMaxColumns: 2,
                            duration: { months: 2 },
                            dateIncrement: { months: 1 }
                        },
                    },
                    eventClick: function (info) {
                        var id = info.event.id;
                        var _details = $("#" + id);
                        _details.modal("show");
                    },
                    eventClassNames: function(arg) {
                        const bgColor = arg.backgroundColor;

                        if (bgColor === "#dc3545") {
                            return ['event-sold-out'];
                        } else if (bgColor === "#EF7215") {
                            return ['event-high-demand'];
                        } else if (bgColor === "#28a745") {
                            return ['event-available'];
                        }
                    }
                });
                calendar.render();
            } else {
                // Update existing calendar events
                calendar.removeAllEvents();
                calendar.addEventSource(events);
            }
        }

        function getTicketBookings(params) {
            if (!organizer_event_calendar_ajax_lock) {
                organizer_event_calendar_ajax_lock = true;
                $.ajax({
                    type: "POST",
                    url: "/ajax/organizer_event_calendar/ticket_bookings",
                    data: params,
                })
                .done(function (data) {
                    if (data.bookings) {
                        renderEventCalendar(data.bookings);
                    }
                    if (data.html) {
                        $("#event-booked-calendar").after(data.html);
                    }
                })
                .fail(function (data) {
                    if (data.responseJSON?.redirect_url) {
                        window.location.href = data.responseJSON.redirect_url;
                    }
                })
                .always(function () {
                    organizer_event_calendar_ajax_lock = false;
                });
            }
        }

        $(document).on("click", ".fc-prev-button, .fc-next-button", function () {
            const view = calendar.view;
            const start = view.currentStart.toISOString().split('T')[0];
            const end = view.currentEnd.toISOString().split('T')[0];

            const updatedParams = { ...params, start, end };
            getTicketBookings(updatedParams);
        });

        getTicketBookings(params);

        $('#order_origin').on('change', function() {
            const channel = $(this).val();
            params.order_origin = channel;
            $("#event_calendar_form").submit();
        });
        
        $(document).on("submit", "#event_calendar_form", function (e) {
            e.preventDefault();
            getTicketBookings(params);
        });
    }
});
